window.addEventListener("scroll", function () {
    const element = document.getElementById("main-navigation");
    if (window.scrollY > 100) {
        element.classList.add("reverse");
    } else {
        element.classList.remove("reverse");
    }
});


$(document).on('click', '.news-tab-heading > div', function (e) {
    console.log(e.currentTarget);
    const n = $(e.currentTarget).data('target');
    const targetLink = $(e.currentTarget).data('link');
    console.log(n);
    $('.news-tab-heading > div').removeClass('active');
    $(e.currentTarget).addClass('active');
    $('.news-tab').removeClass('active');
    $('#news-tab-'+n).addClass('active');
    $('#news-general-readmore').attr('href', targetLink)
});

$(document).on('click', '#home-overlay-click', function(){
    window.location.href = '/giao-dich-bat-dong-san'
})


var arrFeatures = ['#features', '#user-features', '#broker-features', '#support-features'];
var indexFeatures = -1;
var intervalFeatures = null;
const intervalTimer = 10000;

function changeCardHomeFeature(id){
    $('.card-home-1').removeClass('activated');
    $(id+'-card').addClass('activated');
    $('.features-section').removeClass('activated');
    $(id).addClass('activated');

}

function autoPlayFeature(){
    indexFeatures++;
    changeCardHomeFeature(arrFeatures[indexFeatures]);
    console.log(indexFeatures);
    if(indexFeatures == arrFeatures.length -1) indexFeatures = -1;
}

$(document).on('click', '.card-home-1', function (e) {
    const target = $(e.currentTarget).data('target');
    // intervalFeatures = null;
    changeCardHomeFeature(target);
    // intervalFeatures = setInterval(autoPlayFeature, intervalTimer)
})

$(document).on('click', '#menu-toggle-open', function (e) {
    $('.mobile-nav').addClass('open');
})
$(document).on('click', '#menu-toggle-close', function (e) {
    $('.mobile-nav').removeClass('open');
})

$(document).ready(function () {
    setTimeout(function () {
        $('.news-tab-heading > div:nth-child(1)').addClass('active');
        $('.news-tab').removeClass('active');
        $('#news-tab-0').addClass('active');
    }, 1000)

    // autoPlayFeature()
    // intervalFeatures = setInterval(autoPlayFeature, intervalTimer)
})



async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const mapContainer = document.getElementById("hero-map");
    if(mapContainer){
        map = new Map(mapContainer, {
            center: { lat: 16.069157545075466, lng: 108.20720686637648 },
            zoom: 14,
            disableDefaultUI: true,
            mapTypeId: "hybrid", // hoặc "hybrid"
        });
    }
}

initMap();


async function initMapContact() {
    // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const mapContainer = document.getElementById('map-contact');
    if(mapContainer) {
        const map = new Map(mapContainer, {
            center: {lat: 16.074326058729028, lng: 108.2124678837333},
            zoom: 16,
            mapId: '4504f8b37365c3d0',
            disableDefaultUI: true,
        });
        const marker = new AdvancedMarkerElement({
            map,
            position: {lat: 16.074326058729028, lng: 108.2124678837333},
        });
    }
}
initMapContact()
